import { http } from '@/http/axios.js'
export function getLoginCodeAPI(mobile) {
  return http({
    url: '/capital/auth/login/smsCode',
    method: 'post',
    data: { mobile }
  })
}
